import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  projectDetailsAPI,
  freelancerProjectsAPI,
  manageInvitationAPI,
  markAsCompleteProjectAPI,
  markStartProjectEndPointURL,
  uploadDeliveableProjectFindJobEndPointURL,
  fetchFreelancerDeliveableProjectDetailsEndPointURL,
  freelancerprojectDetailsAPI,
} from "../../../../routes/apiurls";

// fetch-my-projects
export const fetchMyProjects = createAsyncThunk(
  "fetch-my-projects",
  async () => {
    try {
      const response = await API_REQUEST({
        url: freelancerProjectsAPI,
        method: "GET",
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

// fetch-project-details
export const fetchProjectDetails = createAsyncThunk(
  "fetch-project-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: projectDetailsAPI + payload,
        method: "GET",
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchFreelancerProjectDetails = createAsyncThunk(
  "fetch-freelancer-project-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: freelancerprojectDetailsAPI + payload,
        method: "GET",
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchProjectDliveableFreelancerDetails = createAsyncThunk(
  "fetch-projec-deliveable-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: fetchFreelancerDeliveableProjectDetailsEndPointURL + payload,
        method: "GET",
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);
// manage-invitation
export const manageInvitation = createAsyncThunk(
  "manage-invitation",
  async (props) => {
    try {
      const { payload, callback } = props || {};
      const response = await API_REQUEST({
        url: manageInvitationAPI,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const markAsCompleteProject = createAsyncThunk(
  "mark-project-complete",
  async (props) => {
    try {
      const { payload, callback } = props || {};
      const response = await API_REQUEST({
        url: markAsCompleteProjectAPI,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const markAsStartProject = createAsyncThunk(
  "mark-start-project",
  async (props) => {
    try {
      const { payload, callback } = props || {};
      const response = await API_REQUEST({
        url: markStartProjectEndPointURL,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

export const uploadDeliverableData = createAsyncThunk(
  "upload-deliverable-data",
  async (props) => {
    try {
      const { payload, callback } = props || {};
      const response = await API_REQUEST({
        url: uploadDeliveableProjectFindJobEndPointURL,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);